import { gsap } from 'gsap';

/*
* cc-stageHeroIntro
*/

const ccStageHeroIntro = {
    cfg:  {
        name: 'Stage Hero Intro +',
        selectors: {
            root: '.cc-stageHeroIntro',
        },
        classes: {
        },
        el: {
            $root: undefined,
        },
    },

    setElements() {
        this.cfg.el.$root = document.querySelector(this.cfg.selectors.root);
    },

    addEventListeners() {
        const p = this.$('text > p');

        const tl = gsap.timeline({
            defaults: { ease: 'power3.out' },
        });

        for (const el of p) {
            tl.to(el, { opacity: 1, duration: .6, delay: .3 })
        }

        tl.to(this.cfg.el.$root, { background: 'transparent', delay: .5, duration: 3 });
        tl.set(this.cfg.el.$root, { zIndex: 1, position: 'absolute' }, '<');
        tl.to(this.cfg.el.$root, { autoAlpha: 0, delay: 1, duration: 2 });
    },

    init() {
        console.debug(`Init: ${this.cfg.name}`);
        this.setElements();

        if (this.cfg.el.$root) {
            this.addEventListeners();
        }
    },

    $(bemId) {
        return this.cfg.el.$root.querySelectorAll(`${this.cfg.selectors.root}__${bemId}`);
    }
};

export default ccStageHeroIntro;
